document.body.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul")
    };
    this.elements.button.addEventListener("click", this.openSelector.bind(this));
    this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
  }
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE")
      return;
    this.hidePanel();
    this.elements.button.focus();
  }
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form)
      form.submit();
  }
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
  }
  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);


function open_drawer__menu() {
  let menu_drawer;
    menu_drawer = document.querySelector('.menu-drawer--variant');
  document.addEventListener("click", function(e) {
    if(e.target.classList.contains('show_mobile_menu')){
      menu_drawer.classList.toggle('show_drawer_menu');
      document.body.classList.toggle('overflow-hidden')
      document.body.toggleAttribute('data-menu-open');
    }else if(e.target.classList.contains('menu-drawer--close')){
      menu_drawer.classList.toggle('show_drawer_menu');
      document.body.classList.toggle('overflow-hidden')
      document.body.toggleAttribute('data-menu-open');
    }
  })

  // Swipe-to-close (mobile): drawer enters from the left, swipe left closes it.
  let touchStartX = 0;
  let touchStartY = 0;
  const SWIPE_CLOSE_THRESHOLD = 60;
  menu_drawer.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  menu_drawer.addEventListener('touchmove', function(e) {
    if (!menu_drawer.classList.contains('show_drawer_menu')) return;
    const deltaX = e.touches[0].clientX - touchStartX;
    const deltaY = e.touches[0].clientY - touchStartY;
    // Blocks iOS Safari's edge-swipe-back gesture from hijacking the close swipe.
    if (deltaX < 0 && Math.abs(deltaX) > Math.abs(deltaY)) {
      e.preventDefault();
    }
  }, { passive: false });
  menu_drawer.addEventListener('touchend', function (e) {
    if (!menu_drawer.classList.contains('show_drawer_menu')) return;
    const deltaX = e.changedTouches[0].clientX - touchStartX;
    const deltaY = e.changedTouches[0].clientY - touchStartY;
    if (deltaX < -SWIPE_CLOSE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
      menu_drawer.classList.remove('show_drawer_menu');
      document.body.classList.remove('overflow-hidden');
      document.body.removeAttribute('data-menu-open');
    }
  }, { passive: true });
}

if (document.querySelector('.menu-drawer')) {
  open_drawer__menu();
}
